import { render, staticRenderFns } from "./holiday_index.vue?vue&type=template&id=48a5ece6&scoped=true"
import script from "./holiday_index.vue?vue&type=script&lang=js"
export * from "./holiday_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5ece6",
  null
  
)

export default component.exports